// LanguageSwitcher.js - Some style improvements
import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button 
        onClick={() => changeLanguage('en')} 
        className={`language-button ${i18n.language === 'en' ? 'active' : ''}`}
      >
        English
      </button>
      <button 
        onClick={() => changeLanguage('ar')} 
        className={`language-button ${i18n.language === 'ar' ? 'active' : ''}`}
      >
        العربية
      </button>
    </div>
  );
};

export default LanguageSwitcher;